<template>
  <div class="title-card" @click="$emit('click')">
    <div class="title-header">
      <h3>{{ title.sNombreTitulo }}</h3>
      <span class="badge">Título {{ title.iNumeroTitulo }}</span>
    </div>
    <div class="title-info">
      <span class="module-count">{{ title.modulesCount }} códigos</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleCard',
  props: {
    title: {
      type: Object,
      required: true
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.title-card {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-left: 4px solid #3498db;
}

.title-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.title-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.title-header h3 {
  color: #2c3e50;
  margin: 0;
  flex: 1;
}

.badge {
  background: #3498db;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  margin-left: 10px;
}

.title-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.module-count {
  color: #7f8c8d;
  font-size: 14px;
}

@media (max-width: 768px) {
  .title-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .badge {
    margin-left: 0;
    margin-top: 8px;
  }
}
</style>